import { render, staticRenderFns } from "./Tours.vue?vue&type=template&id=e7821ed2&"
import script from "./Tours.vue?vue&type=script&lang=js&"
export * from "./Tours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports